import Utils from '../../common/Utils';

/**
 * NshopTempl Template
 * @category testApp
 */
class NshopTempl {
	/**
	 * Sub1 Templ
	 * @param  {Object} _d={}
	 */
	static getTempl(_d={}, _powerbookDomain='') {
		let nshopLiveToday = _d.NshopToday.live.goodsList ,
			//nshopLiveRecommend = _d.NshopRecommend.live.goodsList,
			//nshopFrontierToday = _d.NshopToday.frontier.goodsList,
		//	nshopFrontierRecommend = _d.NshopRecommend.frontier.goodsList,
			nshopMygodstone = _d.NshopMygodstone.count;

		const listLiveToday = nshopLiveToday.map( (item, index) => {
					if(index<8) return NshopTempl.listTemplToday(item,_powerbookDomain);
				}).join('') || NshopTempl.noData();
			// listLiveRecommend = nshopLiveRecommend.map( (item, index) => {
			// 		if(index<4) return NshopTempl.listTemplRecommend(item,_powerbookDomain);
			// 	}).join('') || NshopTempl.noData(); //,
			// listFrontierToday = nshopFrontierToday.map( (item, index) => {
			// 		if(index<8) return NshopTempl.listTemplToday(item,_powerbookDomain, 'frontierserver');
			// 	}).join('') || NshopTempl.noData() ,
			// listFrontierRecommend = nshopFrontierRecommend.map( (item, index) => {
			// 		if(index<4) return NshopTempl.listTemplRecommend(item,_powerbookDomain, 'frontierserver');
			// 	}).join('') || NshopTempl.noData();

		return `
    <div class="nshop-godstone is-live is-active">
			<div class="nshop-godstone-today">
				<h3 class="nshop-godstone-title">오늘의 상품</h3>
				<ul class="nshop-godstone-list">
					${listLiveToday}
				</ul>
				<p class="nshop-godstone-time">새 상품 등장까지 <strong class="time">${_d.NshopToday.live.remainTime == null ? '' : _d.NshopToday.live.remainTime.hour+'시간'} ${_d.NshopToday.live.remainTime == null ? '' : _d.NshopToday.live.remainTime.minute+'분'}</strong></p>
			</div>
		</div>
        `;

  // <div class="nshop-godstone is-frontier">
  //     <div class="nshop-godstone-today">
  //     <h3 class="nshop-godstone-title">오늘의 상품</h3>
  //   <ul class="nshop-godstone-list">
  //     ${listFrontierToday}
  //     </ul>
  //     <p class="nshop-godstone-time">새 상품 등장까지 <strong class="time">${_d.NshopToday.frontier.remainTime == null ? '' : _d.NshopToday.frontier.remainTime.hour+'시간'} ${_d.NshopToday.frontier.remainTime == null ? '' : _d.NshopToday.frontier.remainTime.minute+'분'}</strong></p>
  //   </div>
  //   <div class="nshop-godstone-recommend">
  //     <h3 class="nshop-godstone-title">추천 상품</h3>
  //   <ul class="nshop-godstone-list">
  //     ${listFrontierRecommend}
  //     </ul>
  //     </div>
  //     </div>
	}


	static listTemplToday(_d,_powerbookDomain,_serverType){
		let _items = _d.items;

		let thumbIcon = ( _d.goodsIconId != undefined && _d.goodsIconId == 1 || _items[0] == undefined || _items[0].icon == null || _items[0].icon == undefined ) ? 'https://wstatic-cdn.plaync.com/bns/v1/img/main/icon-nshop-box.png' : _items[0].icon;
		let itemGrade = ( _items[0] == undefined || _items[0].grade == undefined) ? 'itemgrade-0' : `itemgrade-${_items[0].grade}`;
		let _itemInner = `<div class="frame"><img class="thumb" src="${thumbIcon}"></div>
				<div class="info">
					<div class="name ${itemGrade}">${_d.name}</div>
					<span class="count">${Utils.addThousandSeparatorCommas(_d.basicSalePrice)}</span>
				</div>`;

		//let _item = ( _serverType == "frontierserver" ) ? `<div class="link">${_itemInner}</div>` : `<a class="link" href="${_powerbookDomain}/wiki/${_items[0].name}">${_itemInner}</a>`;
		let _item = `<div class="link">${_itemInner}</div>`;

		return `
		<li class="nshop-godstone-item">
			${_item}
		</li>`;
	}

	// static listTemplRecommend(_d,_powerbookDomain,_serverType){
	// 	let _items = _d.items;
	// 	const listFrontierRecommendItems = _items.map( (item, index) => {
	// 		if(index<8) return NshopTempl.listTemplRecommendItem(item,_powerbookDomain,_serverType);
	// 	}).join(', ');
  //
	// 	let thumbIcon = ( _items[0] == undefined || _items[0].icon == undefined ) ? 'https://wstatic-cdn.plaync.com/bns/v1/img/main/icon-nshop-box.png' : _items[0].icon;
  //
	// 	return `
	// 	<li class="nshop-godstone-item">
	// 		<div class="link">
	// 			<div class="frame"><img class="thumb" src="${thumbIcon}">${(_items.length >= 2) ? '<span class="icon-bundle">번들</span>' : '' }</div>
	// 			<div class="info"><span class="name">${_d.name}</span><span class="count">${Utils.addThousandSeparatorCommas(_d.basicSalePrice)}</span></div>
	// 		</div>
	// 		<dl class="acquire">
	// 			<dt class="acquire-title">획득 가능한 아이템</dt>
	// 			<dd class="acquire-list">${listFrontierRecommendItems}</dd>
	// 		</dl>
	// 	</li>`;
	// }

	// static listTemplRecommendItem(_d,_powerbookDomain,_serverType) {
	//   if(_d == null)return ;
	// 	let itemGrade = (_d.grade == undefined) ? 'itemgrade-0' : `itemgrade-${_d.grade}`;
  //
	// //	let _item = ( _serverType == "frontierserver" ) ? `<span class="${itemGrade}">${_d.name}</span>` : `<a class="${itemGrade}" href="${_powerbookDomain}/wiki/${_d.name}">${_d.name}</a>`;
	// 	let _item = `<span class="${itemGrade}">${_d.name}</span>`;
	// 	return _item;
	// }

	static noData() {
		return `<div class="nodata"><p> 신석샵 상품이 존재하지 않습니다. </p></div>`;
	}


} // end of class

export default NshopTempl;